import { render, staticRenderFns } from "./AuthInfoForCompany.vue?vue&type=template&id=986fd87c&scoped=true&"
import script from "./AuthInfoForCompany.vue?vue&type=script&lang=js&"
export * from "./AuthInfoForCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986fd87c",
  null
  
)

export default component.exports